import 'css-chunksrc/client/pages/exportsPage/customCpamReport/filters/yearSelector/years/styles.scss';export default {
  "calendar": "_calendar_1wybp_1",
  "heading": "_heading_1wybp_7",
  "title": "_title_1wybp_18",
  "iconBox": "_iconBox_1wybp_27",
  "disabledIconBox": "_disabledIconBox_1wybp_41",
  "icon": "_icon_1wybp_27",
  "rightIcon": "_rightIcon_1wybp_58",
  "leftIcon": "_leftIcon_1wybp_62",
  "main": "_main_1wybp_66",
  "years": "_years_1wybp_70",
  "row": "_row_1wybp_75",
  "year": "_year_1wybp_70",
  "selected": "_selected_1wybp_102",
  "footer": "_footer_1wybp_113",
  "clear": "_clear_1wybp_119",
  "button": "_button_1wybp_135"
};